import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { HOST } from "../../store/types";

import GetCards from "../../components/GetCards/GetCards";
import Tabs from '../../components/Tabs/Tabs.jsx'
import TabsDescription from '../../components/Tabs-description/Tabs-description.jsx'
import TabsFoto from '../../components/Tabs-foto/Tabs-foto.jsx'
import TabsEvent from "../../components/TabsEvent/TabsEvent";
import {
  LineOneStyled
} from './style.js';
import { Container } from "../../components/Container/Container";
import HeaderPage from "../../components/HeaderPage/HeaderPage";
import i18n from "i18next";
import { useSelector } from "react-redux";
import { ContainerCatalogStyled } from "../../components/Container/style";

const getSlug = (pathname) => pathname.substr(pathname.indexOf('/', 1) + 1);

const Event = () => {
  const [popupIsOpen, setPopupIsOpen] = useState(false);
  const [fotosIndex, setFotosIndex] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [trailer, setTrailer] = useState(false);
  //для компонента Grid
  const [dashboard, setDashboard] = useState(true);
  //контент
  const [contentPage, setContentPage] = useState([]);
  const [redirect, setRedirect] = useState(false);

  const token = useSelector((store) => store.auth.dataToken.token);
  const location = useLocation();

  const isMounted = useRef(true);
  useEffect(() => () => { isMounted.current = false }, []);

  const onToggleViewClick = (x) => {
    setDashboard(x);
  };

  const handleClick = (id, statusTreiler) => {
    setPopupIsOpen((prev) => !prev);
    setFotosIndex(id);
    setTrailer(statusTreiler);
  };

  const handleClickPlus = () => {
    setFotosIndex((prev) => prev + 1);
  };

  const handleClickMinus = () => {
    setFotosIndex((prev) => prev - 1);
  };

  //Получаем содержимое страницы
  const _onContentPage = useCallback((slug, authToken) => {
    let bearer;
    if (authToken) {
      bearer = 'Bearer ' + authToken
    }
    fetch(`${HOST}/v1/events/${slug}`, {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Authorization': bearer,
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        return res.json();
      })
      .then((body) => {
        if (!isMounted.current) return;

        if (body.message) {
          setRedirect(true);
        } else {
          setContentPage(body.data);
        }
      });
  }, []);

  // componentDidMount + componentDidUpdate: загрузка и переход на другое мероприятие
  useEffect(() => {
    _onContentPage(getSlug(location.pathname), token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  //редирект на 404
  if (redirect) { return <Redirect to='/404' />; }

  // обработка даты мероприятия
  let date = "";
  let getDateS = String(contentPage.date_start);
  let getDateE = String(contentPage.date_end);
  const dateMonth = [i18n.t(`event.january`), i18n.t(`event.february`), i18n.t(`event.march`), i18n.t(`event.april`), i18n.t(`event.may`), i18n.t(`event.june`), i18n.t(`event.july`), i18n.t(`event.august`), i18n.t(`event.september`), i18n.t(`event.october`), i18n.t(`event.november`), i18n.t(`event.december`)];

  let daysCoincide = getDateS.substr(8, 2) !== getDateE.substr(8, 2); // совпадает день начала и окончания
  let monthsCoincide = getDateS.substr(5, 2) !== getDateE.substr(5, 2); // совпадает месяц начала и окончания
  let yearsCoincide = getDateS.substr(0, 4) !== getDateE.substr(0, 4); // совпадает год начала и окончания

  if (contentPage.date_end) {
    date = +getDateS.substr(8, 2); // добавляем число начала
    date += monthsCoincide ? ` ${dateMonth[+getDateS.substr(5, 2) - 1]}` : ""; // если месяц начала отличается от месяца окончания, то добавляем месяц начала
    date += yearsCoincide ? ` ${getDateS.substr(0, 4)}` : ""; // если год начала отличается от года окончания, то добавляем год начала
    date += (daysCoincide || monthsCoincide || yearsCoincide) ? " - " : ""; // если дата начала и окончания отличаются, то ставим тере
    date += (daysCoincide || monthsCoincide || yearsCoincide) ? `${+getDateE.substr(8, 2)}` : ""; // если дата начала и окончания отличаются, то ставим день окончания
    date += ` ${dateMonth[+getDateE.substr(5, 2) - 1]}`; // добавляем месяц окончания
    date += ` ${getDateE.substr(0, 4)}` // добавляем год окончания
  }

  // менеджеры
  let managers = [];
  contentPage.managers && contentPage.managers.map((item) => { return (managers.push(item)) });
  // кадры
  let photos = [];
  contentPage.photos && contentPage.photos.map((item) => { return (photos.push(item.media)) });
  let photosSmall = [];
  contentPage.photos && contentPage.photos.map((item) => { return (photosSmall.push(item.media_preview)) });
  let videos = [];
  contentPage.videos && contentPage.videos.map((item) => { return (videos.push(item.media)) });

  const testProject = {
    cadre: ["../img-test/video-prev.png", "../img-test/video-prev2.png", "../img-test/video-prev.png", "../img-test/video-prev3.png", "../img-test/video-prev.png", "../img-test/video-prev.png", "../img-test/video-prev3.png"],
    posters: ["video-poster.png", "video-poster.png"],
    ///Вкладка видео, галерея "трейлеры"
    trailerBlock: [{
      title: i18n.t(`event.trailer`),
      embed_url: "https://uma.media/play/embed/0d66ac0a6d2d9821621396c7fd718a02?wmode=opaque&amp;fakeFullscreen=1",
      duration_text: "03:11",
      preview_ru: "../img-test/video-prev.png",
    },
    {
      title: i18n.t(`event.trailer`),
      embed_url: "https://www.youtube.com/embed/ZlDiZO5x1o4",
      duration_text: "03:11",
      preview_ru: "../img-test/video-prev.png",
    }],
    //Вкладка видео, галерея "эпизоды"
    season: [
      [
        { video: "https://uma.media/play/embed/0d66ac0a6d2d9821621396c7fd718a02", time: "03:11", previewVideo: "../img-test/video-prev.png" },
        { video: "https://uma.media/play/embed/af0d250d98bc9966cdbdbbc6fec555b9", time: "03:11", previewVideo: "../img-test/video-prev.png", },
        { video: "https://uma.media/play/embed/0d66ac0a6d2d9821621396c7fd718a02", time: "03:11", previewVideo: "../img-test/video-prev.png", },
        { video: "https://uma.media/play/embed/af0d250d98bc9966cdbdbbc6fec555b9", time: "03:11", previewVideo: "../img-test/video-prev.png", }
      ],
      [
        { video: "https://uma.media/play/embed/0d66ac0a6d2d9821621396c7fd718a02", time: "03:11", previewVideo: "../img-test/video-prev.png" },
        { video: "https://uma.media/play/embed/af0d250d98bc9966cdbdbbc6fec555b9", time: "03:11", previewVideo: "../img-test/video-prev.png", },
      ]
    ],
    description: [
      { name: i18n.t(`event.dates`), text: date },
      { name: i18n.t(`event.location`), text: contentPage.location ? contentPage.location : "" },
      { name: i18n.t(`event.format`), text: contentPage.format ? contentPage.format : "" },
      { name: i18n.t(`event.website`), text: contentPage.website ? <a href={contentPage.website} target="_blank" rel="noopener noreferrer">{contentPage.website}</a> : "" },
      { name: i18n.t(`event.program`), text: contentPage.schedule ? <a href={contentPage.schedule} target="_blank" rel="noopener noreferrer">{contentPage.schedule.substr(1 + contentPage.schedule.lastIndexOf("/"))}</a> : "" }
    ],
    location: {
      img: contentPage.location_image,
      pdf: contentPage.location_info,
    }
  }

  const tabsMenu = [
    { tabsName: i18n.t(`events.synopsis`) },
    { tabsName: (contentPage.selection && i18n.t(`events.our_materials`)) },
    /*{tabsName: "Видео"},*/
    { tabsName: ((photos.length > 0 || videos.length > 0) && i18n.t(`events.photo_video`)) },
    //для отображение переключателя карточек во вкладке "Наши материалы"
    { events: true },
  ]

  return (
    <ContainerCatalogStyled>
      {/*        <GetCards
          sourceCards="banners"
          contentType="мероприятие"
          cardDisplayType="topbanner"
        />*/}
      <HeaderPage
        /* Leftimg={'/img-test/c710x400.png'}*/
        Title={i18n.t(`events.about_the_event`)}
        Leftdiv={contentPage.top_description}
        Rightdiv={(i18n.language === 'en') ? contentPage.image_en : contentPage.image_ru}
        Rightvideo={contentPage.video_embed} />

      <Container>
        <Tabs
          tabsMenu={tabsMenu}
          imgPoster={(i18n.language === 'en') ? (contentPage.poster_en === "" ? "../img-test/default-card-img.jpg" : contentPage.poster_en) : (contentPage.poster_ru === "" ? "../img-test/default-card-img.jpg" : contentPage.poster_ru)}
          textSend={i18n.t(`events.make_appointment`)}
          type="event"
          //для пререключения вкладок
          onToggleViewClick={(x) => onToggleViewClick(x)}
          dashboard={dashboard}
          id={contentPage && contentPage.id}
          isInFavourites={contentPage.isInFavourites && contentPage.isInFavourites}
          typeBookmark="events"

          firstTabs={<TabsDescription
            description={testProject.description}
            bigDescription={contentPage.short_description ? contentPage.short_description : ""}
            name={contentPage.title ? contentPage.title : ""}
            moreDetails={contentPage.description ? contentPage.description : ""}
            manager={managers[0] ? managers : false}
            location={testProject.location}
          />}

          secondTabs={<TabsEvent
            dashboard={dashboard}
            manager={managers[0] ? managers : false}
            getSelections={contentPage.selection && contentPage.selection.id}
            location={testProject.location}
          />}

          thirdTabs={<TabsFoto
            posters={testProject.posters}
            cadresSmall={photosSmall}
            cadre={photos}
            handleClickMinus={handleClickMinus}
            handleClickPlus={handleClickPlus}
            handleClick={handleClick}
            popupIsOpen={popupIsOpen}
            fotosIndex={fotosIndex}
            manager={managers[0] ? managers : false}
            location={testProject.location}
            videos={testProject.trailerBlock}
            event={true}
          />}

        />
        <LineOneStyled></LineOneStyled>
        <GetCards sourceCards="events" link="/events" type="events" title={i18n.t(`events.we_also_recommend`)} cardDisplayType="carousel" />
      </Container>
    </ContainerCatalogStyled>
  );
};

export default Event;
